import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { register } from "./serviceWorkerRegistration";


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);


if ('serviceWorker' in navigator) {
  let refreshing = false;

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;

    refreshing = true;
    window.location.reload();
  });

  register({
    onUpdate: (registration) => {
      registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
    },
  });

  const checkForUpdate = async () => {
    const registration = await navigator.serviceWorker.getRegistration();
    await registration?.update();
  };

  navigator.serviceWorker.ready.then(checkForUpdate);

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      checkForUpdate();
    }
  });
}

